import { AuthContextUserType } from '@sparelabs/context-propagation'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'
import { PermissionSetType, PermissionType } from '@sparelabs/permissions'

export enum AuthorizationRoleStatus {
  Active = 'active',
  Archived = 'archived',
}

export interface IAuthorizationRoleListQueryParams extends IListModelQueryParamValues {
  roleType?: 'default' | 'custom'
  search?: string
  status?: AuthorizationRoleStatus
}

export interface IAuthorizationRolePostBody {
  name: string
  description?: string
}

export interface IAuthorizationRolePatchBody {
  name?: string
  description?: string
  status?: AuthorizationRoleStatus
}

export interface IAuthorizationRoleResponse extends IModelJsonValues {
  name: string
  description?: string
  organizationId: string
  isDefaultSpareRole: boolean
  status: AuthorizationRoleStatus
  permissionSets?: IAuthorizationPermissionSetResponse[]
}

export interface IAuthorizationRolePermissionSetPutBody {
  permissionSetIds: string[]
}

export interface IUserRolePatchBody {
  roleIds: string[]
}

export interface IUserRoleResponse extends IUserRolePatchBody {}

export interface IAuthorizationRolePermissionSetResponse extends IModelJsonValues {
  permissionSet: {
    id: string
    key: PermissionSetType
  }
}

//
// Permission Set Operations and Types
//

export interface IAuthorizationPermissionSetResponse extends IModelJsonValues {
  key: PermissionSetType
}

//
// Super Admin Operations and Types
//

export interface IAuthorizationSuperAdminRoleResponse extends IModelJsonValues {
  name: string
}

export interface IAuthorizationSuperAdminUserRolePutBody extends IUserRolePatchBody {}

export interface IAuthorizationSuperAdminUserRolePutResponse extends IAuthorizationSuperAdminUserRolePutBody {}

export interface ISuperAdminAuthorizationUserRolesResponse {
  roles: IAuthorizationSuperAdminRoleResponse[]
}

//
// User permissions
//

export interface IAuthorizationPermissionsResponse {
  permissions: PermissionType[]
}

export interface IAuthorizationPermissionsQueryParams {
  userTypes?: AuthContextUserType[]
}

//
// User Group Types
//

export enum AuthorizationUserGroupStatus {
  Active = 'active',
  Archived = 'archived',
}

export interface IAuthorizationUserGroupResponse extends IModelJsonValues {
  name: string
  description?: string
  status: AuthorizationUserGroupStatus
  organizationId: string
  isAdministratorGroup: boolean
  key: string | null
}

export interface IAuthorizationUserGroupListQueryParams extends IListModelQueryParamValues {
  status?: AuthorizationUserGroupStatus
  isAdministratorGroup?: boolean
  search?: string
}

export interface IAuthorizationUserGroupPostBody {
  name: string
  description?: string
}

export interface IAuthorizationUserGroupPatchBody {
  name?: string
  description?: string
  status?: AuthorizationUserGroupStatus
}

//
// User Group Membership Types
//
export interface IAuthorizationGroupMembershipResponse extends IModelJsonValues {
  userId: string
  userGroupId: string
}

export interface IAuthorizationGroupMembershipListQueryParams extends IListModelQueryParamValues {
  userId?: string
  userGroupId?: string
}

export interface IAuthorizationGroupMembershipPostBody {
  userGroupId: string
  userId: string
}

//
// Access Grant Types
//

export enum AccessGrantObjectType {
  Organization = 'organization',
  EligibilityCaseType = 'engageCaseType',
  EligibilityForm = 'engageForm',
  OperationsProvider = 'operationsProvider',
}

export interface IAccessGrantResponse extends IModelJsonValues {
  id: string
  userGroupId: string
  roleId: string
  objectId: string
  objectType: AccessGrantObjectType
}

export interface IAccessGrantPostBody {
  userGroupId: string
  roleId: string
  objectId: string
  objectType: AccessGrantObjectType
}

export interface IAccessGrantListQueryParams extends IListModelQueryParamValues {
  userGroupId?: string
  objectType?: AccessGrantObjectType
  roleId?: string
}

export interface IAuthorizationGroupMembershipBulkUpdatePostBody {
  userGroupIds: string[]
  userId: string
}
